<template>
  <DropdownMenuRoot v-model:open="isOpen">
    <div
      class="w-8 h-8 bg-brand-bgdivider-20 rounded-[100px] backdrop-blur-[35px] justify-center items-center gap-2 flex"
    >
      <div class="relative flex items-center justify-center">
        <DropdownMenuTrigger
          :aria-label="$t('channel.thread.dropdown.aria')"
          @click.stop
        >
          <Icon
            icon="ph:dots-three"
            class="text-basics-secondary-80"
            width="24"
            height="24"
          />
        </DropdownMenuTrigger>
      </div>
    </div>

    <DropdownMenuPortal>
      <DropdownMenuContent
        class="outline-none shadow bg-brand-bgdivider-20 text-brand-tertiary-60 backdrop-blur-3xl p-2 rounded-xl will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade z-[999999999]"
        :side-offset="5"
      >
        <DropdownMenuItem
          class="flex items-center select-none outline-none data-[highlighted]:bg-brand-primary text-brand-primary data-[highlighted]:text-basics-primary rounded-md px-2 py-1 gap-2"
          @click="emit('report')"
        >
          <Icon icon="fluent:flag-16-regular" width="24" height="24" />
          {{
            $t("channel.thread.report.title", {
              type: $t(
                `channel.thread.report.type.${isThread ? "thread" : "reply"}`,
              ),
            })
          }}
        </DropdownMenuItem>

        <DropdownMenuItem
          v-if="canEdit && isThread"
          class="flex items-center select-none outline-none data-[highlighted]:bg-brand-primary text-brand-primary data-[highlighted]:text-basics-primary rounded-md px-2 py-1 gap-2"
          @click="emit('edit')"
        >
          <Icon icon="ph:pencil" width="24" height="24" />
          {{ $t("channel.thread.edit") }}
        </DropdownMenuItem>

        <DropdownMenuItem
          v-if="canDelete"
          class="flex items-center select-none outline-none data-[highlighted]:bg-brand-primary data-[highlighted]:text-basics-primary text-basics-accent-red rounded-md px-2 py-1 gap-2"
          @click="emit('delete')"
        >
          <Icon icon="ph:trash" width="24" height="24" />
          {{
            $t("channel.thread.delete.title", {
              type: $t(
                `channel.thread.report.type.${isThread ? "thread" : "reply"}`,
              ),
            })
          }}
        </DropdownMenuItem>

        <DropdownMenuItem
          v-if="canPin && isThread"
          class="flex items-center select-none outline-none data-[highlighted]:bg-brand-primary text-brand-primary data-[highlighted]:text-basics-primary rounded-md px-2 py-1 gap-2"
          @click="emit('togglePin')"
        >
          <Icon
            :icon="isPinned ? 'mdi:pin-off' : 'mdi:pin'"
            width="24"
            height="24"
          />
          {{ isPinned ? $t("channel.thread.unpin") : $t("channel.thread.pin") }}
        </DropdownMenuItem>

        <DropdownMenuArrow class="fill-brand-bgdivider-20 backdrop-blur-3xl" />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>

<script setup lang="ts">
import { Icon } from "@iconify/vue";
import {
  DropdownMenuArrow,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from "reka-ui";
import { ref } from "vue";

defineProps<{
  isThread: boolean;
  isPinned?: boolean;
  canDelete: boolean;
  canEdit: boolean;
  canPin: boolean;
}>();

const emit = defineEmits<{
  report: [];
  edit: [];
  delete: [];
  togglePin: [];
}>();

const isOpen = ref(false);
</script>
